import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, ExternalLink, ShieldCheck } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

interface CaktoPaymentWrapperProps {
 order_id?: string;
 isSubscription?: boolean;
 onSuccess?: () => void;
 onError?: (error: string) => void;
 buttonText?: string;
 disabled?: boolean;
 amount?: number;
 planId?: string;
}

const CaktoPaymentWrapper: React.FC<CaktoPaymentWrapperProps> = ({
 order_id,
 isSubscription = false,
 amount = 15,
 planId,
 onSuccess,
 onError = (err) => console.error(err),
 buttonText = "Pagar com Cakto",
 disabled = false,
}) => {
 const { user } = useAuth();
 const [loading, setLoading] = useState(false);

 const startCheckout = async () => {
 setLoading(true);
 
 // 1. MASTER REDIRECT (Pula o Iframe branco e abre o link direto para evitar erros)
 if (isSubscription) {
 console.log("Cakto: Redirecionando para Assinatura...");
 try {
 let finalUrl = "https://pay.cakto.com.br/39vdrgy_820769";
 
 if (amount === 25) {
 finalUrl = "https://pay.cakto.com.br/q98k2jf_912228";
 } else if (amount === 9.9) {
 finalUrl = "https://pay.cakto.com.br/353qzvv_995497";
 } else {
 const { data: settings } = await (supabase.from("site_settings" as any).select("*") as any);
 const dynamicUrl = (settings as any[])?.find((s: any) => s.key === "cakto_subscription_url")?.value;
 if (dynamicUrl) finalUrl = dynamicUrl;
 }
 
 const urlObj = new URL(finalUrl);
 if (user?.email) urlObj.searchParams.set("email", user.email);
 if (user?.id) {
   const refValue = `${user.id}|${planId || (amount === 25 ? "lunar" : amount === 15 ? "estrela" : "basico")}`;
   urlObj.searchParams.set("ref", refValue);
   urlObj.searchParams.set("refId", refValue);
   urlObj.searchParams.set("sck", user.id);
   urlObj.searchParams.set("src", user.id);
 }
 
 window.open(urlObj.toString(), '_blank');
 if (onSuccess) onSuccess();
 } catch (e) {
 console.error("Error fetching cakto subscription url:", e);
 const fallbackUrl = amount === 25 ? "https://pay.cakto.com.br/q98k2jf_912228" : amount === 9.9 ? "https://pay.cakto.com.br/353qzvv_995497" : "https://pay.cakto.com.br/39vdrgy_820769";
 const urlObj = new URL(fallbackUrl);
 if (user?.email) urlObj.searchParams.set("email", user.email);
 if (user?.id) {
   const refValue = `${user.id}|${planId || (amount === 25 ? "lunar" : amount === 15 ? "estrela" : "basico")}`;
   urlObj.searchParams.set("ref", refValue);
   urlObj.searchParams.set("refId", refValue);
   urlObj.searchParams.set("sck", user.id);
   urlObj.searchParams.set("src", user.id);
 }
 window.open(urlObj.toString(), '_blank');
 if (onSuccess) onSuccess();
 }
 setLoading(false);
 return;
 }

 // 2. FLOW PARA OUTROS PRODUTOS (FOTOS/LIVE)
 try {
 console.log("[Cakto] Redirecionando para link oficial confirmado...");
 // Forçamos o link que o Hudson confirmou como funcional para evitar tela branca
 const officialLink = "https://pay.cakto.com.br/39vdrgy_820769";
 
 const urlObj = new URL(officialLink);
 if (user?.email) urlObj.searchParams.set("email", user.email);
 if (order_id) {
   urlObj.searchParams.set("ref", `order_${order_id}`);
   urlObj.searchParams.set("refId", `order_${order_id}`);
 }
 if (user?.id) {
   urlObj.searchParams.set("sck", user.id);
   urlObj.searchParams.set("src", user.id);
 }
 
 window.location.href = urlObj.toString();
 return;
 } catch (err: any) {
 console.error("[Cakto] Erro crítico:", err);
 window.location.href = "https://pay.cakto.com.br/39vdrgy_820769";
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="flex flex-col gap-4">
 <Button
 onClick={startCheckout}
 disabled={disabled || loading}
 className="w-full -white font-bold h-16 rounded-xl shadow-lg transform active:scale-95 transition-all flex items-center justify-center gap-2 text-lg"
 >
 {loading ? (
 <Loader2 className="h-6 w-6 animate-spin" />
 ) : (
 <>
 <ExternalLink className="w-5 h-5" />
 {buttonText}
 </>
 )}
 </Button>
 
 <div className="flex items-center justify-center gap-2 text-[10px] text-muted-foreground bg-secondary/20 p-2 rounded-lg">
 <ShieldCheck className="w-3 h-3 text-green-500" />
 Pagamento 100% Seguro Processado pela Cakto
 </div>
 </div>
 );
};

export default CaktoPaymentWrapper;
